import { render, staticRenderFns } from "./GridIdeaCard.vue?vue&type=template&id=3b9da43e&scoped=true&"
import script from "./GridIdeaCard.vue?vue&type=script&lang=js&"
export * from "./GridIdeaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9da43e",
  null
  
)

export default component.exports